export default "__VITE_ASSET__EYrpMzHk__"